import {BundeslandEnum} from '../v2024';

export const BundeslandEnumLabels = {
    NUMBER_28: 28 as BundeslandEnum,
    NUMBER_9: 9 as BundeslandEnum,
    NUMBER_11: 11 as BundeslandEnum,
    NUMBER_30: 30 as BundeslandEnum,
    NUMBER_24: 24 as BundeslandEnum,
    NUMBER_22: 22 as BundeslandEnum,
    NUMBER_26: 26 as BundeslandEnum,
    NUMBER_40: 40 as BundeslandEnum,
    NUMBER_23: 23 as BundeslandEnum,
    NUMBER_5: 5 as BundeslandEnum,
    NUMBER_27: 27 as BundeslandEnum,
    NUMBER_10: 10 as BundeslandEnum,
    NUMBER_32: 32 as BundeslandEnum,
    NUMBER_31: 31 as BundeslandEnum,
    NUMBER_21: 21 as BundeslandEnum,
    NUMBER_41: 41 as BundeslandEnum
};

